export enum AddressType {
	pickup = "pickup",
	delivery = "delivery",
}